import { gql } from '@apollo/client';
import { STOCK_ALLOCATION_PLAN_FIELDS } from '../queries/stockAllocations';

export const CREATE_STOCK_ALLOCATION_PLAN = gql`
  mutation CreateStockAllocationPlan($portfolioId: ID!, $name: String!, $currency: String!, $items: [StockAllocationItemInput!]!) {
    createStockAllocationPlan(portfolioId: $portfolioId, name: $name, currency: $currency, items: $items) {
      ...StockAllocationPlanFields
    }
  }
  ${STOCK_ALLOCATION_PLAN_FIELDS}
`;

export const UPDATE_STOCK_ALLOCATION_PLAN = gql`
  mutation UpdateStockAllocationPlan($portfolioId: ID!, $planId: ID!, $name: String, $items: [StockAllocationItemInput!]) {
    updateStockAllocationPlan(portfolioId: $portfolioId, planId: $planId, name: $name, items: $items) {
      ...StockAllocationPlanFields
    }
  }
  ${STOCK_ALLOCATION_PLAN_FIELDS}
`;

export const DELETE_STOCK_ALLOCATION_PLAN = gql`
  mutation DeleteStockAllocationPlan($portfolioId: ID!, $planId: ID!) {
    deleteStockAllocationPlan(portfolioId: $portfolioId, planId: $planId)
  }
`;

export const RECORD_STOCK_ALLOCATION_BUY = gql`
  mutation RecordStockAllocationBuy($portfolioId: ID!, $planId: ID!, $itemId: ID!, $input: StockAllocationBuyInput!) {
    recordStockAllocationBuy(portfolioId: $portfolioId, planId: $planId, itemId: $itemId, input: $input) {
      transactionId planId itemId
    }
  }
`;
